import * as React from "react"
import {Box, Grid, Typography} from "@mui/material";
import {BasicTableSeeker, CardSeeker, ImageSeeker} from "@ui-seeker/core"

import {BACKEND_APIS} from "@constants";
import {imageModalData} from "@signals";
import {reverseMatcherImageSizeValue} from "../../@signals";


export default function ReverseMatcherTargetProduct({ data={} }) {
    return <CardSeeker elevation={3} sx={{ width: 1, height: 0.8, overflowY: 'auto' }}>
        <Grid container spacing={2}>
            <Grid item xs={3} display="flex" justifyContent="center" alignItems="center">
                <ImageSeeker
                    useSpinner
                    lazyLoad={false}
                    src={`${BACKEND_APIS.BACKEND}/sku/image/${data.skuID}`}
                    sx={{ border: '1px solid', borderColor: 'divider', width: reverseMatcherImageSizeValue.value, height: 'auto', cursor: 'pointer' }}
                    onClick={() => imageModalData.value = {
                        title: data.skuName,
                        fullSRC: `${BACKEND_APIS.BACKEND}/sku/image/${data.skuID}`
                    }}
                />
            </Grid>

            <Grid item xs={9} display="flex" flexDirection="column" alignItems="flex-end">
                <Typography display="flex" alignItems="center">
                    {data.skuName}
                </Typography>
                <Typography color="text.disabled">
                    EAN: {data.ean || "-"}
                </Typography>
                <Typography color="text.disabled">
                    Brand: {data.brand || "-"}
                </Typography>
                <Typography color="text.disabled"  mb={2}>
                    Line: {data.line || "-"}
                </Typography>
            </Grid>

            <Grid item xs={12}>
                <BasicTableSeeker
                    data={[data]}
                    headers={[[
                        {label: 'SKU ID'},
                        {label: 'Reference'}
                    ]]}
                    columns={[
                        { name: 'skuID', render: value => <Box textAlign="center">{value || "-"}</Box> },
                        { name: 'reference', render: value => <Box textAlign="center">{value || "-"}</Box> }
                    ]}
                    cardProps={{ sx: { boxShadow: 0 } }}
                />
            </Grid>
        </Grid>
    </CardSeeker>
}